<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'artikel', 'suche', 'index']"> Artikel </a>
      </li>
      <li>
        {{ article?.rma }}
      </li>
    </ul>
  </div>
  @if (article) {
    <a [routerLink]="['/', 'artikel', 'neu', article.id]" class="bm-btn">
      <i class="fa fa-arrow-right"></i> Vorlage für Wareneingang
    </a>
    <a [routerLink]="['/', 'artikel', article.id, 'edit']" class="bm-btn"> <i class="fa fa-pencil"></i> Bearbeiten </a>
    <button (click)="onDelete()" class="bm-btn bm-btn-error"><i class="fas fa-trash-alt"></i> Artikel löschen</button>
  }
</div>

@if (article) {
  <div class="page-content page-frame overflow-y-auto">
    <div class="page-sheet max-w-6xl mx-auto grid grid-cols-2 gap-4">
      <section class="bm-card bm-card-sm border border-base-300 rounded row-span-2">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title">Stammdaten</h2>
          <table class="bm-table bm-table-xs">
            <tr>
              <td>RMA</td>
              <td>
                <span class="font-bold">{{ article.rma }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <a
                  target="_blank"
                  [href]="
                    env.apiURL +
                    'articles/' +
                    article.id +
                    '.pdf?' +
                    'rma=' +
                    article.rma +
                    '&sn=' +
                    article.serial_number +
                    '&template=' +
                    article.description +
                    '&partNr=' +
                    article.part_nr +
                    '&purchaseDate=' +
                    (article.purchase_date | date: 'dd.MM.yyyy') +
                    '&deliveryDate=' +
                    (article.delivery_date | date: 'dd.MM.yyyy') +
                    '&storageBin=' +
                    article.storage_bin_label
                  "
                  class="bm-btn"
                >
                  <i class="fa fa-print mr-2"></i> Etikett drucken
                </a>
              </td>
            </tr>
            <tr>
              <td>Typ</td>
              <td>
                <div class="flex flex-col gap-1">
                  <a class="bm-link bm-link-hover" [routerLink]="['/', 'artikelvorlagen', article.template_id]">
                    <i class="fa fa-cubes mr-2"></i>{{ article.description }}
                  </a>
                  {{ article.product_category }}
                  {{ article.vendor }}
                </div>
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                @if (article.status === "NEW") {
                  <span>Neu</span>
                }
                @if (article.status === "USED_TESTED") {
                  <span>Gebraucht und getestet</span>
                }
                @if (article.status === "USED_UNTESTED") {
                  <span>Gebraucht und NICHT getestet</span>
                }
              </td>
            </tr>
            <tr>
              <td>Seriennummer</td>
              <td>
                {{ article.serial_number }}
              </td>
            </tr>
            <tr>
              <td>MAC Adresse</td>
              <td>
                {{ article.mac_address || "-" }}
              </td>
            </tr>
            <tr>
              <td>BadPart</td>
              <td>
                {{ article.bad_part ? "Ja" : "-" }}
              </td>
            </tr>
            <tr>
              <td>BadPart-Beschreibung:</td>
              <td>
                {{ article.bad_part_description || "-" }}
              </td>
            </tr>
            <tr>
              <td>Besitzer</td>
              <td>
                @if (article.owner === "BENTOMAX") {
                  <span>Bentomax GmbH</span>
                }
                @if (article.owner === "CUSTOMER" && article.owner_customer_id) {
                  <span>
                    <a
                      class="bm-link bm-link-hover"
                      target="_blank"
                      href="/admin/customer/{{ article.owner_customer_id }}/show"
                    >
                      {{ article.owner_name }}
                    </a>
                  </span>
                }
              </td>
            </tr>
          </table>
        </div>
      </section>
      <section class="bm-card bm-card-sm border border-base-300 rounded">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title">Anlieferung</h2>
          <table class="bm-table bm-table-xs">
            <tr>
              <td>Lieferant:</td>
              <td>
                @if (article.supplier_id) {
                  <span>
                    <a
                      class="bm-link bm-link-hover"
                      target="_blank"
                      href="/admin/supplier/{{ article.supplier_id }}/show"
                      >{{ article.supplier_name }}</a
                    >
                  </span>
                }
                @if (!article.supplier_id) {
                  <span>
                    {{ article.supplier_other }}
                  </span>
                }
              </td>
            </tr>
            <tr>
              <td>Kaufdatum:</td>
              <td>{{ article.ext_delivery_note_number }}</td>
            </tr>
            <tr>
              <td>Kaufdatum:</td>
              <td>
                {{ article.purchase_date | date: "dd.MM.yyyy" }}
              </td>
            </tr>
            <tr>
              <td>Lieferdatum:</td>
              <td>
                {{ article.delivery_date | date: "dd.MM.yyyy" }}
              </td>
            </tr>
          </table>
        </div>
      </section>
      <section class="bm-card bm-card-sm border border-base-300 rounded">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title">Lieferscheine</h2>
          @if (deliveryNotes) {
            <table class="bm-table bm-table-xs">
              @for (deliveryNote of deliveryNotes; track deliveryNote) {
                <tr>
                  <td>
                    <a class="bm-link bm-link-hover" [routerLink]="['/', 'lieferscheine', deliveryNote.id]">
                      <span class="fa fa-truck mr-2"></span>{{ deliveryNote.number }}
                    </a>
                  </td>
                  <td [align]="'right'">{{ deliveryNote.note_date | date: "dd.MM.yyyy" }}</td>
                </tr>
              }
            </table>
          }
        </div>
      </section>
      <section class="bm-card bm-card-sm border border-base-300 rounded row-span-2">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title">Standort</h2>
          <table class="bm-table bm-table-xs">
            <tr>
              <td>Status</td>
              <td>
                @if (article.location === "WAREHOUSE") {
                  <span>Im Lager</span>
                }
                @if (article.location === "SHIPPING") {
                  <span>Im Versand</span>
                }
                @if (article.location === "CONSUMED") {
                  <span>Verbraucht</span>
                }
              </td>
            </tr>
            <tr>
              <td>Lager</td>
              <td>
                @if (article.warehouse_id) {
                  <a class="bm-link bm-link-hover" [routerLink]="['/', 'lager', article.warehouse_id]">
                    {{ article.warehouse_name }}
                  </a>
                }
              </td>
            </tr>
            <tr>
              <td>Platz</td>
              <td>
                {{ article.storage_bin_label }}
              </td>
            </tr>
          </table>
        </div>
      </section>
      <section class="bm-card bm-card-sm border border-base-300 rounded">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title">Tickets</h2>
          @if (tickets) {
            <table class="bm-table bm-table-xs">
              @for (ticket of tickets; track ticket) {
                <tr>
                  <td>
                    <a class="bm-link bm-link-hover" [routerLink]="['/', 'ticket', ticket.id]">
                      <i class="fa fa-ticket mr-2"></i>{{ ticket.order_nr }}
                    </a>
                  </td>
                  <td>
                    {{ ticket.project_name }}
                  </td>
                  <td>{{ ticket.first_working_day | date: "dd.MM.yyyy" }}</td>
                </tr>
              }
            </table>
          }
        </div>
      </section>
      <section class="bm-card bm-card-sm border border-base-300 rounded col-span-2">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title">Letzten Änderungen</h2>
          <ag-grid-angular
            class="ag-theme-quartz w-full"
            style="height: 400px"
            [theme]="hawkTheme"
            [loadThemeGoogleFonts]="true"
            [rowData]="histories"
            [defaultColDef]="historyDefaultColDef"
            [columnDefs]="historyColDefs"
            [localeText]="locale"
            (gridReady)="onHistoryGridReady($event)"
          />
        </div>
      </section>
    </div>
  </div>
}
